const _LAYOUT = {
  brand: "STAKEHOLDER",
  logo: "/login_background.jpg",
};

export default _LAYOUT;
